<template>
  <tr :class="getRowClass()"
      @click="onRowClick">
    <template v-if="isItemRow">
      <!-- 商品明細 -->
      <template v-for="col in itemRowColumns">
        <td v-show="col.show == null || col.show"
            :key="getUuid(col)"
            :colspan="col.colspan"
            :class="col.class">
          <OrderDetailItemsToolTip
              v-if="col.slot==='toolTip' && showTooltip"
              class="item-detail-table-tooltip"
              :is-item-row="true"
              :is-order-item-row="isOrderItemRow"
              :is-bundle-header-row="isBundleHeaderRow"
              :mode="mode"
              :order-item="row"
              :order-items="rows"
              :type="type"
              @addOrderItem="addOrderItem"
              @addItemPriceAdjustment="addItemPriceAdjustment"
              @removeRow="removeRow" />
          <div v-else-if="col.slot==='editableIcon'">
            <i v-show="showEditableIcon"
                class="fas fa-edit editableIcon" />
          </div>
          <BaseCell
              v-else
              :properties="col"
              :display-item="row" />
        </td>
      </template>
    </template>
    <template v-else-if="isComponentRow">
      <!-- 構成品 -->
      <template v-for="col in itemComponentColumns">
        <td v-show="(col.show == null || col.show)"
            :key="getUuid(col)"
            :colspan="col.colspan"
            :class="col.class">
          <OrderDetailItemsToolTip
              v-if="col.slot==='toolTip' && showTooltip"
              class="item-detail-table-tooltip"
              :is-component-row="true"
              :mode="mode"
              :parent-item="parentRow"
              :order-item="row"
              :order-items="rows"
              :type="type"
              @addOrderItem="addOrderItem"
              @removeRow="removeRow" />
          <div v-else-if="col.slot==='editableIcon'">
            <i v-show="showEditableIcon"
                class="fas fa-edit editableIcon" />
          </div>
          <BaseCell
              v-else
              :properties="col"
              :display-item="row" />
        </td>
      </template>
    </template>
    <template v-else-if="isItemAdjustmentRow">
      <!-- 単品値引 -->
      <template v-for="col in itemAdjustmentColumns">
        <td v-show="col.show == null || col.show"
            :key="getUuid(col)"
            :colspan="col.colspan"
            :class="col.class">
          <OrderDetailItemsToolTip
              v-if="col.slot==='toolTip' && showTooltip"
              class="item-detail-table-tooltip"
              :row="row"
              :type="type"
              @removeRow="removeRow" />
          <BaseCell
              v-else
              :properties="col"
              :display-item="row" />
        </td>
      </template>
    </template>
    <template v-else-if="isAdjustmentRow">
      <!-- 小計値引 -->
      <template v-for="col in adjustmentColumns">
        <td v-show="col.show == null || col.show"
            :key="getUuid(col)"
            :colspan="col.colspan"
            :class="col.class">
          <OrderDetailItemsToolTip
              v-if="col.slot==='toolTip' && showTooltip"
              class="item-detail-table-tooltip"
              :row="row"
              :type="type"
              @removeRow="removeRow" />
          <BaseCell
              v-else
              :properties="col"
              :display-item="row" />
        </td>
      </template>
    </template>
  </tr>
</template>

<style scoped>
tr.giftItems td:nth-child(n + 2),
tr.shippingItems td:nth-child(n + 2),
tr.adjustment td:nth-child(n + 2) {
    border-top: solid 1px;
    border-color:#c7d3d9;
}
tr.giftItems ~ tr.giftItems td,
tr.shippingItems ~ tr.shippingItems td,
tr.adjustment ~ tr.adjustment td {
    border-top: initial;
    border-color:initial;
}
.adjustment-row-label {
  text-align: right;
  color: #ff5a5a;
}
tr td.tag-cell {
  vertical-align: middle;
}
tr td >>> .el-tag {
  display: block;
}
tr td >>> .el-tag:nth-child(n + 2) {
  margin-top: 5px;
}

.component-disp-arrorw {
  padding: 0px;
  margin: 0px;
}

.component-disp-arrorw >>> button {
  border: none;
  background: none;
  width: 100%;
  max-height: 100%;
  height: 100%;
  padding: 0px;
  margin: 0px;
}
.component-disp-arrorw >>> div.base-cell {
  padding: 0px!important;
  margin: 0px;
  height: 38px;
}

.component-position >>> div div {
  padding-right: 10px;
}

</style>

<script>
import _ from 'lodash'
import math from '@/utils/math'
import uuid from 'uuid/v4'
import { mapGetters } from 'vuex'
import * as define from '@/define'

import x from '@/components/mixins/mixin'
import orderUtil from '@/components/mixins/orderUtil'
import OrderDetailItemsToolTip from '@/components/pages/order/OrderDetailItemsToolTip'

import BaseCell, { ELEMENT_TYPE } from '@/components/molecules/BaseCell'

const ROW_TYPE = [
  'items',
  'giftItems',
  'shippingItems',
  'itemAdjustment',
  'giftItemAdjustment',
  'shippingItemAdjustment',
  'adjustment',
  'components'
]

const ROW_TYPE_TO_ADJUSTMENT_TYPE = {
  'items': 'itemAdjustment',
  'giftItems': 'giftItemAdjustment',
  'shippingItems': 'shippingItemAdjustment'
}

export default {
  name: 'OrderDetailItemsRow',
  components: {
    BaseCell,
    OrderDetailItemsToolTip
  },
  mixins: [x, orderUtil],
  inject: ['parentValidator'],
  props: {
    parent: {
      type: Object,
      default: () => ({})
    },
    originData: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: Number,
      default: define.ORDER_MODE.NORMAL
    },
    type: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'origin', 'total'].indexOf(value) !== -1
      }
    },
    row: {
      type: Object,
      default: () => ({})
    },
    parentRow: {
      type: Object,
      default: () => {}
    },
    rows: {
      type: Array,
      default: () => ([])
    },
    rowType: {
      type: String,
      default: 'items',
      validator: function (value) {
        return ROW_TYPE.indexOf(value) !== -1
      }
    },
    showTooltip: {
      type: Boolean,
      default: false
    },
    showComponent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    define: () => define,
    ...mapGetters('OrderDetail', {
      orderDetail: 'orderDetail'
    }),
    ...mapGetters({
      getServiceSiteConfig: 'getServiceSiteConfig',
      orderItemTypeName: 'orderItemTypeName'
    }),
    isItemRow () {
      return ['items', 'giftItems', 'shippingItems'].includes(this.rowType)
    },
    isComponentRow () {
      return this.rowType === 'components'
    },
    isBundleHeaderRow () {
      return Boolean(this.row.isBundle)
    },
    isOrderItemRow () {
      return this.rowType === 'items'
    },
    isItemAdjustmentRow () {
      return ['itemAdjustment', 'giftItemAdjustment', 'shippingItemAdjustment'].includes(this.rowType)
    },
    isAdjustmentRow () {
      return this.rowType === 'adjustment'
    },
    itemRowColumns () {
      return this.rowType === 'items'
        ? (this.isBundleHeaderRow
          ? [
            { path: null, slot: 'editableIcon', colspan: 1 },
            { type: 'String', path: 'position', colspan: 1, width: 100 },
            {
              label: '', path: '', elementType: ELEMENT_TYPE.BUTTON,
              click: this.componentArrowClick,
              width: 150, colspan: 2, columnKey: 'componentShow',
              class: 'component-disp-arrorw', buttonClass: () => 'el-collapse-item__arrow el-icon-arrow-right' + (this.showComponent ? ' is-active' : '')
            },
            {
              type: 'String', elementType: ELEMENT_TYPE.TAG, path: this.orderStatus,
              size: 'mini', colspan: 3, class: { 'tag-cell': true }
            },
            {
              type: 'String', elementType: ELEMENT_TYPE.TAG, path: this.orderItemType,
              size: 'mini', colspan: 1, class: { 'tag-cell': true }
            },
            { type: 'String', path: 'productId', colspan: 2 },
            { type: 'String', path: 'lineitemText', colspan: 4 },
            { type: 'Number', path: 'basePrice.gross', colspan: 3, class: { right: true } },
            { type: 'Number', path: 'qty.current', colspan: 3, class: { right: true } },
            { type: 'Number', path: 'price.gross', colspan: 3, class: { right: true } },
            { path: null, slot: 'toolTip' }
          ] : [
            { path: null, slot: 'editableIcon', colspan: 1 },
            { type: 'String', path: 'position', colspan: 3 },
            {
              type: 'String', elementType: ELEMENT_TYPE.TAG, path: this.orderStatus,
              size: 'mini', colspan: 3, class: { 'tag-cell': true }
            },
            {
              type: 'String', elementType: ELEMENT_TYPE.TAG, path: this.orderItemType,
              size: 'mini', colspan: 1, class: { 'tag-cell': true }
            },
            { type: 'String', path: 'productId', colspan: 2 },
            { type: 'String', path: 'lineitemText', colspan: 4 },
            { type: 'Number', path: 'basePrice.gross', colspan: 3, class: { right: true } },
            { type: 'Number', path: 'qty.current', colspan: 3, class: { right: true } },
            { type: 'Number', path: 'price.gross', colspan: 3, class: { right: true } },
            { path: null, slot: 'toolTip' }
          ]
        )
        : [
          { path: null, colspan: 13 },
          { type: 'String', path: 'lineitemText', colspan: 4 },
          { path: null, colspan: 3 },
          { type: 'Number', path: 'price.gross', colspan: 3, class: { right: true } },
          { path: null, slot: 'toolTip' }
        ]
    },
    itemComponentColumns () {
      return [
        { path: null, slot: 'editableIcon', colspan: 1 },
        { type: 'String', path: 'position', colspan: 3, class: 'right component-position' },
        {
          type: 'String', elementType: ELEMENT_TYPE.TAG, path: this.orderStatus,
          size: 'mini', colspan: 3, class: { 'tag-cell': true }
        },
        { type: 'String', path: null, colspan: 1 },
        { type: 'String', path: 'productId', colspan: 2 },
        { type: 'String', path: 'lineitemText', colspan: 4 },
        { type: 'Number', path: 'basePrice.gross', colspan: 3, class: { right: true } },
        { type: 'Number', path: 'qty.current', colspan: 3, class: { right: true } },
        { path: null, colspan: 3 },
        { path: null, slot: 'toolTip' }
      ]
    },
    itemAdjustmentColumns () {
      return [
        { path: null, colspan: 12 },
        {
          type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '調整金額',
          colspan: 1, class: { 'adjustment-row-label': true }
        },
        { type: 'String', path: 'lineitemText', colspan: 4 },
        { path: null, colspan: 3 },
        { type: 'Number', path: 'price.gross', colspan: 3, class: { right: true } },
        { path: null, slot: 'toolTip' }
      ]
    },
    adjustmentColumns () {
      return this.type !== 'total' ? [] : [
        {
          type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '調整金額',
          colspan: 1, class: { 'adjustment-row-label': true }
        },
        {
          type: 'String', path: 'lineitemText', colspan: 19,
          class: { 'border-top': false, 'border-bottom': false }
        },
        {
          type: 'Number', path: 'price.gross', colspan: 3,
          class: { right: true, 'border-top': false, 'border-bottom': false }
        },
        { path: null, slot: 'toolTip', class: { 'border-top': false, 'border-bottom': false } }
      ]
    },
    showEditableIcon () {
      return this.type === 'normal' &&
        this.$_orderUtil_canEditOrderItem(this.row, this.isOrderItemRow, this.mode, this.originData)
    }
  },
  watch: {
    'row.price.gross' (val, old) {
      this.$emit('requestCalculate')
    },
    'row.qty.current' (val, old) {
      if (this.mode === define.ORDER_MODE.NORMAL || this.mode === define.ORDER_MODE.CANCEL || this.rowType !== 'items') {
        return
      }
      this.calculatePrice(this.row)
    }
  },
  created () {
    this.$validator = this.parentValidator
  },
  methods: {
    getRowClass () {
      return {
        discount: _.get(this.row, 'price.gross', 0) < 0,
        [this.rowType]: true,
        'adjustment-row': this.isItemAdjustmentRow || this.isAdjustmentRow
      }
    },
    onRowClick (event) {
      if (event.srcElement.parentElement.parentElement.classList.contains('component-disp-arrorw')) {
        // tooltipのセルクリック時は何もしない
        return
      }
      if (event != null) {
        if (!window.getSelection().isCollapsed) {
          // 文字列が選択されている場合、何もしない.
          return
        }

        // クリック無効なtdを取得する
        const find = event.target
          .closest(`tr.${this.rowType} > td`)
          .closest(`tr > td`)
          .querySelector('td > .item-detail-table-checkbox, td > .item-detail-table-tooltip')
        if (find != null) {
          return
        }
      }

      this.$emit('rowClick', event, this.row, this.rowType)
    },
    addOrderItem (row) {
      const newRow = _.cloneDeep(row.model)
      if (this.isComponentRow) {
        this.parentRow.bundleItems.push(newRow)
        this.calculateCurrentQty(newRow)
        // 追加した行をクリックしたことにする
        this.$emit('rowClick', null, newRow, 'components', true, row.prev)
      } else {
        let shipments = this.getShipmentSelectBoxList()
        if (shipments.length > 0) {
          row.model.shipment.id = shipments[0].code
        }
        this.rows.push(newRow)
        this.calculateCurrentQty(newRow)
        this.calculatePrice(newRow)
        // 追加した行をクリックしたことにする
        this.$emit('rowClick', null, newRow, 'items', true, row.prev)
      }
    },
    /**
     * 単品値引行追加
     */
    addItemPriceAdjustment () {
      const result = this.searchArrayObjectByKeyValue(
        this.rows,
        { orderDetailItemsKey: this.row.orderDetailItemsKey })

      const newRow = this.createEmptyPriceAdjustment()
      if (!_.has(this.rows[result.index], 'priceAdjustments')) {
        this.$set(this.rows[result.index], 'priceAdjustments', [])
      }
      this.rows[result.index].priceAdjustments.push(newRow)
      // 追加した調整金額行をクリックしたことにする
      this.$emit('rowClick', null, newRow, ROW_TYPE_TO_ADJUSTMENT_TYPE[this.rowType], true)
    },
    /**
     * 行削除
     */
    removeRow () {
      if (_.has(this.row, 'uuid')) {
        this.$set(this.row, 'delete', 1)
      } else {
        const result = this.searchArrayObjectByKeyValue(
          this.rows, { orderDetailItemsKey: this.row.orderDetailItemsKey })
        this.rows.splice(result.index, 1)
      }
      this.$emit('requestCalculate')
    },
    createEmptyPriceAdjustment () {
      return {
        promotionId: '',
        campaignId: '',
        couponId: '',
        reasonCode: '',
        lineitemText: '',
        basePrice: { net: 0, gross: 0 },
        price: { net: 0, gross: 0 }
      }
    },
    getUuid (row) {
      if (!row.orderDetailItemsKey) {
        row.orderDetailItemsKey = uuid()
      }
      return row.orderDetailItemsKey
    },
    orderStatus (row) {
      return ['items', 'components'].includes(this.rowType) ? this.$_orderUtil_itemOrderStatusTag(row) : []
    },
    componentArrowClick (event) {
      this.$emit('changeComponentOpenState', this.row)
    },
    /**
     * @param {Array} array 検索対象の配列
     * @param {Object} keyValue 検索対象の key と value
     * @return {Object}
     * {index: 配列インデックス, record: {} 見つかった最初のレコード
     */
    searchArrayObjectByKeyValue (array, keyValue) {
      if (!Array.isArray(array)) {
        array = []
      }
      let key = ''
      let value = ''
      for (const k in keyValue) {
        key = k
        value = keyValue[key]
      }
      let index
      const record = array.filter((v, i) => {
        if (v[key] === value) {
          index = i
          return true
        }
      })
      return record[0] ? { index, record: record[0] } : null
    },
    getShipmentSelectBoxList () {
      const shipList = this.orderDetail.shipments.map((shipment, i) => ({ code: shipment.id, name: '配送先' + (parseInt(i) + 1) }))
      return shipList
    },
    calculatePrice (row) {
      row.price.gross = math.multiply([row.basePrice.gross, row.qty.current])
      _.forEach(row.priceAdjustments, adjustment => {
        adjustment.price.gross = math.multiply([adjustment.basePrice.gross, row.qty.current])
      })
      this.$emit('requestCalculate')
    },
    calculateCurrentQty (row) {
      const qty = row.qty
      qty.current = math.add([
        qty.ordered,
        -qty.canceled,
        -qty.inshipCanceled,
        -qty.transfer,
        -qty.receiveFixed,
        qty.exOut,
        qty.exOutExported,
        qty.exOutFixed,
        -qty.exIn,
        -qty.exInFixed
      ])
    },
    /**
     * 注文明細種類を返却します。
     * @param {Object} 情報
     * @returns {Array} tag 生成のための配列
     */
    orderItemType: function (row) {
      const val = this.orderItemTypeName(row.orderItemType.toString())
      let orderItemTypeTag = []
      if (row.orderItemType === 2) {
        orderItemTypeTag.push({ label: val, type: 'danger' })
      }
      if (row.orderItemType === 3) {
        orderItemTypeTag.push({ label: val, type: 'success' })
      }
      return orderItemTypeTag
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/order/OrderDetailItemsRow.vue